import axios from 'axios';


const restClient = axios.create({
  baseURL: process.env.REACT_APP_DOMAIN_NODE_ENV,
  timeout: 10000
});
class BaseService {
  /* constructor() {
    this.headers = {};
  }

  setToken(token) {
    this.headers = {
      headers: {
        ...this.headers.headers,
        'X-Access-Token': token
      }
    }
  } */

  get(url, options = {}, headers) {
    return this.request(url, 'get', options, headers);
  }

  post(url, options, headers) {
    return this.request(url, 'post', options, headers);
  }
  postLogin(url, options) {
    return this.requestLogin(url, 'post', options);
  }

  put(url, options, headers) {
    return this.request(url, 'put', options, headers);
  }

  del(url, headers) {
    return this.request(url, 'delete', headers);
  }

  request(url, method, options, headers = {}) {
    console.info('Service Request to API: ', {
      url: `${url}`,
      method,
      options: JSON.stringify(options),
    });
    return restClient[method](`${url}`, options, headers);
  }

}
export default BaseService;